<template>

  <div class="comment-add">
    <!-- 标题 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"  :close-on-press-escape="false">
      <el-form size="small" :model="form" ref="form">

        <el-form-item label="学校" :label-width="formLabelWidth">
          <span class="f18">{{form.school.name}}</span>
        </el-form-item>
        <el-form-item label="选择专业" prop="major" :label-width="formLabelWidth" :rules="[{ required: true, message: '请选择' }]">
          <el-radio-group v-model="form.major">
            <el-radio :label="1">应用心理专硕</el-radio>
            <el-radio :label="2">心理学学硕</el-radio>
            <el-radio :label="3">心理健康教育专硕</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年份" prop="year" :label-width="formLabelWidth" :rules="[{ required: true, message: '请输入' }]">
          <el-input type="text" v-model="form.year" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="学习方式" prop="study_way" :label-width="formLabelWidth" :rules="[{ required: true, message: '请选择' }]">
          <el-radio-group v-model="form.study_way">
            <el-radio :label="1">全日制</el-radio>
            <el-radio :label="2">非全日制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="招生人数" prop="people_count" :label-width="formLabelWidth" :rules="[{ required: true, message: '请输入' }]">
          <el-input type="text" v-model="form.people_count" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="分数线" prop="score" :label-width="formLabelWidth" :rules="[{ required: true, message: '请输入' }]">
          <el-input type="text" v-model="form.score" autocomplete="off"></el-input>
        </el-form-item>

        <!-- <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
          <el-input type="number" v-model="form.sort" autocomplete="off" class="max-w260"></el-input>
        </el-form-item> -->

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button  type="primary" @click="save" :loading="loading">确 定</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
  import SchoolParamsApi from '@/api/study/school_params.js';
  export default {
    components: {},
    data() {
      return {
        // 类型
        type:'add',  // add:添加  edit:编辑 dateil:详情
        title:'添加',

        //需要提交的表单
        form: {
          name: '',
          status: 1,
          sort: 100,
        },

        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,//是否展示
        //加载
        loading: false,

      };
    },
    props: ['is_open', 'oneform'],//is_open 是否展示
    created() {
      //数据赋值
      this.type = this.oneform.type;

      //类型
      if(this.type == 'edit' || this.type == 'dateil'){
        if(this.type == 'edit' ){
          this.title = '编辑';
        }else{
          this.title = '详情';
        }
        //赋值
        this.form = this.oneform.model;
        if (!this.form.id) this.form.id = '';
      }

      //是否展示
      this.dialogVisible = this.is_open;
    },
    methods: {
      /*保存*/
      save() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            if(self.type == 'add'){
              SchoolParamsApi.add(params).then(data => {
                self.loading = false;
                self.$message({
                  message: '添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }).catch(error => {
                self.loading = false;
              });
            }else if(self.type == 'edit'){

              SchoolParamsApi.edit(params).then(data => {
                self.loading = false;
                self.$message({
                  message: '添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }).catch(error => {
                self.loading = false;
              });
            }
          }
        })
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

    }
  };
</script>

<style>
 .img {
    margin-top: 10px;
    display: flex;
  }
  .img img {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/study/schoolparams/part/Add.vue